/* ============================================================
   Types d'établissement — source unique pour Register + Configuration
   ------------------------------------------------------------
   Le `value` est la chaîne canonique stockée en base dans
   `restaurants.type_cuisine`. Le `label` est l'affichage UI.

   ⚠️ Ne pas changer les `value` après la mise en prod sans
   migration : ce sont les valeurs déjà stockées en DB pour les
   restaurateurs existants.
   ============================================================ */

export const RESTO_TYPES = [
  { value: 'restaurant',  label: 'Restaurant',                emoji: '🍽️' },
  { value: 'glacier',     label: 'Glacier',                   emoji: '🍦' },
  { value: 'cafe',        label: 'Café / Coffee shop',        emoji: '☕' },
  { value: 'brasserie',   label: 'Brasserie / Bar',           emoji: '🍺' },
  { value: 'pizzeria',    label: 'Pizzeria',                  emoji: '🍕' },
  { value: 'japonais',    label: 'Restaurant japonais',       emoji: '🍣' },
  { value: 'thailandais', label: 'Restaurant thaïlandais',    emoji: '🇹🇭' },
  { value: 'healthy',     label: 'Healthy / Végétarien',      emoji: '🥗' },
  { value: 'fastfood',    label: 'Fast-food / Burger',        emoji: '🍔' },
  { value: 'boulangerie', label: 'Boulangerie / Pâtisserie',  emoji: '🥐' },
  { value: 'vins',        label: 'Bar à vins',                emoji: '🍷' },
  { value: 'asiatique',   label: 'Restaurant asiatique',      emoji: '🍜' },
  { value: 'mexicain',    label: 'Mexicain / Tex-Mex',        emoji: '🌮' },
  { value: 'autre',       label: 'Autre',                     emoji: '🏪' },
];

/** Format `emoji label` pour les <option> et selects. */
export const RESTO_TYPE_OPTIONS = RESTO_TYPES.map(t => ({
  value: t.value,
  label: `${t.emoji} ${t.label}`,
}));

/** Map `value` → `emoji` pour lookup rapide (ex: avatar concurrents). */
export const RESTO_TYPE_EMOJI = RESTO_TYPES.reduce((acc, t) => {
  acc[t.value] = t.emoji;
  return acc;
}, {});
